export default {
  vanDatetimePicker: {
    confirm: "Close11",
    cancel: "Cancel",
  },
  name: "Name",
  tel: "Phone",
  save: "Save",
  confirm: "Confirm",
  cancel: "Cancel",
  delete: "Delete",
  complete: "Complete",
  loading: "Loading...",
  telEmpty: "Please fill in the tel",
  nameEmpty: "Please fill in the name",
  nameInvalid: "Malformed name",
  confirmDelete: "Are you sure you want to delete?",
  telInvalid: "Malformed phone number",
  SelectYearMonthDay: "Select Year, Month, Day",
  vanCalendar: {
    end: "End",
    start: "Start",
    title: "Calendar",
    confirm: "Confirm",
    startEnd: "Start/End",
    weekdays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    monthTitle: (year, month) => `${year}/${month}`,
    rangePrompt: (maxRange) => `Choose no more than ${maxRange} days`,
  },
  vanCascader: {
    select: "Select",
  },
  vanContactCard: {
    addText: "Add contact info",
  },
  vanContactList: {
    addText: "Add new contact",
  },
  vanPagination: {
    prev: "Previous",
    next: "Next",
  },
  vanPullRefresh: {
    pulling: "Pull to refresh...",
    loosing: "Loose to refresh...",
  },
  vanSubmitBar: {
    label: "Total：",
  },
  vanCoupon: {
    unlimited: "Unlimited",
    discount: (discount) => `${discount * 10}% off`,
    condition: (condition) => `At least ${condition}`,
  },
  vanCouponCell: {
    title: "Coupon",
    tips: "No coupons",
    count: (count) => `You have ${count} coupons`,
  },
  vanCouponList: {
    empty: "No coupons",
    exchange: "Exchange",
    close: "Close",
    enable: "Available",
    disabled: "Unavailable",
    placeholder: "Coupon code",
  },
  vanAddressEdit: {
    area: "Area",
    postal: "Postal",
    areaEmpty: "Please select a receiving area",
    addressEmpty: "Address can not be empty",
    postalEmpty: "Wrong postal code",
    defaultAddress: "Set as the default address",
    telPlaceholder: "Phone",
    namePlaceholder: "Name",
    areaPlaceholder: "Area",
  },
  vanAddressEditDetail: {
    label: "Address",
    placeholder: "Address",
  },
  vanAddressList: {
    add: "Add new address",
  },
  realName: "real name",

  unionManagement: {
    GuildRegistration: "Guild Registration",
    GuildSettlementWelcomeLine1: "Welcome to",
    GuildSettlementWelcomeLine2: "Rain Chat guild",
    GuildSettlementFormBanner: "Please fill in the guild joining information",
    ApplicantID: "Applicant ID",
    GuildName: "Guild Name",
    PleaseGuildName: "Please enter the guild name",
    PleaseGuildID: "Please enter the Guild ID",
    PleaseInformation: "Please enter your contact information",
    PlatformsWith: "Platforms you have worked with",
    ListOfplatforms: "List the platforms you have worked with",
    GuildSize: "Guild Size",
    EstimatedNumber: "Estimated number of guild hosts",
    Notes:
      "Note: You can contact the guild leader or guild members to obtain the guild ID.",
    Submit: "Submit",
    SubmitSuccess: "Submitted successfully",
    MyGuild: "My Guild",
    VoiceHallOnboarding: "Voice Hall Onboarding",
    WelcomeRainChatVoice: "Welcome to Rain Chat Voice",
    VoiceHallJoinFormBanner: "Please fill in the hall joining information",
    VoiceHallName: "Voice Guild Name",
    PleaseVoiceHallName: "Please enter Voice Guild Name",
    VoiceHallRealName: "Real name",
    PleaseVoiceHallRealName: "Please enter your real name",
    WhatsApp: "WhatsApp",
    PleaseContactInfo: "Please enter your contact information",
    PlatformsCollaborated: "Platforms collaborated with",
    ListPlatformsCollaborated: "List platforms collaborated with",
    VoiceHallScale: "Voice Guild Scale",
    EstimatedAnchors: "Estimated number of Voice guild anchors",
    CertificationType: "Certification Type",
    VoiceHall: "Voice Hall",
    VoiceGuild: "Voice Guild",
    HostName: "Host Name",
    GuildJoinDate: "Guild Join Date",
    TotalMembers: "Total Number of Guild Members",
    TotalPeople: "Total Number of People",
    RoomNicknameLabel: "Room nickname",
    DataDetails: "Data Details",
    PleaseHostID: "Please enter the host ID",
    Search: "Search",
    KickOut: "Kick Out",
    NoData: "No data available",

    InformationData: "Information Data",
    Name: "Name",
    PleaseID: "Please ensure it matches the name on your ID.",
    IdentityCard: "Identity Card",
    YourIDnumber: "Your ID number",
    IDPhoto: "ID Photo",
    PleasePhoto: "Please upload your ID photo.",
    FrontofID: "Front of ID",
    BackofID: "Back of ID",
    NotePlease:
      "Note: Please upload a photo of yourself holding the ID. Your face must be clear and unobstructed, and the ID photo and number must be legible.",
    Country: "Country",
    SelectCountryorRegion: "Select Country/Region",
    BankName: "Bank Name",
    Pleasebankname:
      "Please enter the name of the bank where your account is held.",
    BankCardNumber: "Account Number",
    Pleasebankcardnumber: "Please enter your bank card number.",
    BankCardHolder: "Bank Card Holder",
    Pleasebankcardholder: "Please enter the name of the bank card holder.",
    PhoneNumber: "Phone Number",
    Enterphonenumber: "Enter a valid phone number.",
    Notebankaccount:
      "Note: Please enter the phone number linked to your bank account.",
    WhatsAppContactInformation: "WhatsApp Contact Information",
    Pleaseownnumber: "Please ensure you enter your own phone number.",
    Notecollaborationmatters:
      "Note: The WhatsApp contact provided by the guild will be considered the sole contact for collaboration matters.",
    Email: "Email",
    Pleaseemailaddress: "Please ensure you enter your own email address.",
    Notematters:
      "Note: The email provided by the guild will be considered the sole contact for collaboration matters.",
    BasicInformationSection: "Basic Information",
    RemarksInformationSection: "Additional Information",

    SpecialGiftDetails: "Special Effect Gift Details",

    CurrentDate: "Current Date",
    GoldCoinTransactions: "Gold Bean Lucky Earnings",
    LiveStreamingDuration: "Live Streaming Duration",
    GoldBeanEarnings: "Gold Bean Earnings",
    EffectiveDays: "Effective Days",
    WarningCount: "Warning Count",
    give: "give",

    pleasewait: "Request in progress, please wait...",

    JoinGuild: "Join Guild",
    GuildId: "Guild ID",
    PlaceholderGuildId: "Please Enter Guild ID",
    PlaceholderInvitationCode: "Please provide your guild invitation code",

    InvitationCode: "Invitation code",

    noMore: "No more",

    Recommendation: "Recommendation (Optional)",
    nightLiveTime: "Specific time",

    // Guild Data Page
    GuildTotalData: "Guild total data",
    StatDayUnit: "",
    GuildIncome: "Guild Income",
    AnchorIncome: "Anchor Income",
    EffectiveLive: "Effective Live",
    EffectiveDays: "Effective Days",
    Income: "Income",
    Duration: "Duration",

    // Join Us Page
    JoinUs: "Join Us",
    JoinUsWelcome: "Hi, welcome to join us～",
    JoinUsSelectMethod: "Please select a joining method",
    JoinUsVideoGuild: "Join as Video Guild",
    JoinUsVideoGuildDesc: "You will focus on video streaming",
    JoinUsAudioGuild: "Join as Audio Guild",
    JoinUsAudioGuildDesc: "You will focus on voice streaming",
    JoinUsBack: "Back",
  },

  anchorCenter: {
    todayLiveData: "Today's Live Data",
    time: "Time",
    duration: "Duration",
    income: "Lucky Gold Bean Earnings",
    giftRecord: "Gift Record",
    withdraw: "Withdraw",
    tipsUpdate: "Note: Daily data is updated every minute",
    overallData: "Overall Data",
    totalDays: "Total Days",
    totalDuration: "Total Duration",
    totalTurnover: "Total Lucky Gold Beans",
    totalIncome: "Total Basic Salary",
    totalBeans: "Total Beans",
    dataListMonth: "Data List [{month}]",
    filter: "Filter",
    date: "Date",
    turnover: "Turnover",
    beans: "Beans",
    luckyBeans: "Lucky Beans",
    specialBeans: "Special Beans",
    baseSalary: "Base Salary",
    totalIncomeLabel: "Total Beans",
    anchorTotalData: "Anchor overview",
    anchorNicknamePlaceholder: "Anchor nickname",
    myGuild: "My guild",
    guildNicknamePlaceholder: "Guild nickname",
    anchorDataSection: "Anchor data",
    todayDataTitle: "Today data",
    liveStreamDuration: "Live duration",
    totalGoldBeans: "Total gold beans",
    nextDayLuckyReward: "Next-day lucky reward",
    specialExtraReward: "Special effect extra reward",
    weekLuckyReward: "This week's lucky reward",
    estimatedTotalEarnings: "Estimated total earnings",
    grandTotal: "Total",
    zeroTime: "0h 0m",
    year: "",
    month: "",
  },

  familyMain: {
    anchorList: "Anchor List",
    anchorData: "Anchor Data",
    guildData: "Guild Data",
    guildSummaryTitle: "Guild summary",
    guildList: "Guild list",
    micTime: "Mic Time",
    micTimeData: "Mic Time Data",
    beansDetail: "Beans Detail",
    beansDetailData: "Beans Detail Data",
    withdrawDetail: "Withdraw Detail",
    withdrawDetailData: "Withdraw Detail Data",
    roomData: "Room Data",
    roomDataData: "Room Data Data",
    distributeBeans: "Distribute Beans",
    distributeBeansData: "Distribute Beans Data",
    privateShareStats: "Private/Share Stats",
    privateShareStatsData: "Private/Share Stats Data",
    roomTurnover: "Room Turnover",
    roomTurnoverData: "Room Turnover Data",
    incomeRecord: "Income Record",
    incomeRecordData: "Income Record Data",
    knapsackGiftDetail: "Knapsack Gift Detail",
    knapsackGiftData: "Knapsack Gift Data",
    roomFilterTitle: "Room Filter",
    roomFilterConfirm: "Done",
    allRooms: "All rooms",
    selectRoom: "Select room",
  },
  anchorList: {
    countLabel: "【{count} anchors】",
    searchPlaceholder: "Enter anchor ID",
    search: "Search",
    joinTimeLabel: "Join time: ",
    noData: "No data",
    nickNameFallback: "Anchor nickname",
    invalidUserId: "Please enter a numeric ID",
  },

  salaryMain: {
    searchPlaceholder: "Enter anchor ID to search",
    dateSelect: "Date",
    byDay: "By Day",
    byRange: "By Range",
    searchTime: "Search Time",
    to: " to ",
    dataSummary: "Data Summary",
    totalMicTime: "Total Mic Time",
    totalHeartGiftTurnover: "Total Lucky Gold Beans",
    totalLuxuryGiftTurnover: "Total Gold Beans",
    member: "Members",
    anchorProfile: "Anchor Profile",
    micTime: "Mic Time",
    heartGiftTurnover: "Lucky Gold Beans",
    luxuryGiftTurnover: "Total Gold Beans",
    roomNumber: "Room number",
    pleaseSelectTime: "Select time",
    pleaseEnterNumber: "Please enter a number",
    selectAll: "All",
    minute: "m",
    second: "s",
    anchorTotalData: "Anchor totals",
    totalSpecialEffectBeans: "Total effect gold beans",
    totalAllBeans: "Total gold beans",
  },

  micTime: {
    searchPlaceholder: "Enter anchor ID",
    search: "Search",
    dateSelect: "Date",
    today: "Today",
    thisWeek: "This Week",
    lastWeek: "Last Week",
    totalMicTime: "Total Mic Time",
    date: "Date",
    anchorInfo: "Anchor Info",
    micTime: "Mic Time",
    pleaseSelectTime: "Select time",
    selectAll: "All",
    minute: "m",
    second: "s",
  },

  anchroOtayonii: {
    dateSelect: "Date",
    byDay: "By Day",
    byRange: "By Range",
    searchTime: "Search Time",
    to: " to ",
    dataSummary: "Data Summary",
    totalLuckyGift: "Total Lucky Gift",
    totalSpecialGift: "Total Special Gift",
    totalKnapsackGift: "Total Knapsack Gift",
    anchorInfo: "Anchor Info",
    luckyGift: "Lucky Gift",
    specialGift: "Special Gift",
    knapsackGift: "Knapsack Gift",
    pleaseSelectTime: "Select time",
    selectAll: "All",
  },

  roomCm: {
    dateSelect: "Date",
    today: "Today",
    thisWeek: "This Week",
    lastWeek: "Last Week",
    dataSummary: "Data Summary",
    totalTurnover: "Total Lucky Gold Beans",
    totalTurnoverBeans: "Total Gold Beans",
    date: "Date",
    heartGiftTurnover: "Lucky Gold Beans",
    specialGiftTurnover: "Total Turnover Gold Beans",
    room: "Room",
    pleaseSelectTime: "Select time",
    selectAll: "All",
    minute: "m",
    second: "s",
  },

  weekProfit: {
    dateSelect: "Date",
    time: "Time",
    type: "Type",
    beans: "Beans",
    pleaseSelectTime: "Select time",
  },

  //提现记录
  withdrawRecord: {
    withdrawAmount: "withdraw amount",
    withdrawStatus: "withdraw status",
    NoData: "No data available",

    UnderReview: "Under Review",
    Processing: "Processing",
    Completed: "Completed",
    Rejected: "Rejected",
    Failed: "Failed",

    Pending: "Pending",
    Success: "Success",
    NoMore: "No more",
    PleaseWait: "Please wait...",
    PleaseSelect: "Please select",
    Date: "Date",
    RealAmount: "Real Amount",
    Fee: "Fee",
    Status: "Status",
    Remark: "Remark",
  },

  coinManagement: {
    myGoldenbeans: "My Gold Beans",
    Withdraw: "Withdraw",
    ExchangeGoldCoins: "Exchange",
    HostInformation: "Host Information",
    WithdrawalCurrency: "Withdrawal Currency",
    SelectWithdrawalCurrency: "Please select withdrawal currency",
    FiatCurrency: "Fiat Currency",
    PleaseSelectWithdrawalCurrency: "Please select withdrawal currency",
    tips: "Note：",
    tipsp0: "Withdrawal rate: 10,000 gold beans = 0.5 USD",
    tipsp1:
      "Withdrawal threshold: 100,000 gold beans, withdrawals can only be made in multiples of 10,000 (first withdrawal requires 200,000 gold beans; after a successful withdrawal, the threshold drops to 100,000)",
    tipsp2:
      "Bind a withdrawal account. Due to various payment methods and the lack of fixed documentation in foreign countries, the backend requires multiple types of verification when adding an account as a family head (specific payment methods depend on the current situation).",
    tipsp3: "Host verification is required",
    tipsp4: "Binding a phone number",
    tipsp5:
      "If any of the above steps are incomplete, withdrawal cannot proceed. At this point, the page will prompt the user or guide them to complete the process",
    tipsp6: "① Prompt only",
    tipsp7:
      "② Redirect to the phone number binding page. After completion, return to the previous page.",
    tipsp8:
      "③ Redirect to the identity verification page. After completion, return to the previous page.",
    tipsp9:
      "④ Redirect to the account binding page. After completion, return to the previous page.",

    tipsp10:
      "Withdrawals will incur certain transaction fees, which will vary depending on the channel.",

    tipsp11: "1. Exchange rate: 1000 gold beans = 500 gold coins",
    tipsp12:
      "2. Minimum 5000 gold beans for exchange, must be in multiples of 1000",
    tipsp13:
      "3. Successful exchanges cannot be revoked, please exchange carefully",
    num: "Quantity",
    Custom: "Custom",
    PleaseEnter: "Please enter",
    Redeem: "Redeem",
    SelectType: "Select Type",
    GoldBeans: "Gold Beans",
    GoldCoin: "Coin",
    WithdrawalAmount: "Withdrawal Amount",
    PleaseNum: " Enter the number of coins to withdraw",
    All: "All",
    Withdraw: "Withdraw",

    Incomedetails: "Income details",
    Expensedetails: "Expense details",
    Nobeans: "No redeemable gold beans",

    balance: "Balance",

    Record: "Transaction Record",
    //提现记录
    WithdrawalRecord: "Withdrawal Record",
  },

  contactUs: {
    Officialcustomerservice: "Official Customer Service",
    ContactUs: "Contact Us",
    Issueofguild: "Guild Registration Issues",
  },

  myInvitation: {
    MyGoldBeans: "My Gold Beans",
    Share: "Share to Invite More Friends",
    CopyLink: "Copy Link",
    GoldCoinEarnedToday: "Gold Bean Earned Today",
    TotalGoldCoin: "Total Gold Bean Accumulated",
    tips: "Invite and Bind New Users to Recharge Any Amount to Farn a 1% Gold  Bean(Cannot bind after 48 hours ofregistration)",
    tips2: "Cannot bind after 48 hours of registration",
    MyInvitations: "My Invitations",
    BillingDetails: "Billing Details",
    Total: "Total",
    People: "People",
    GoldCoinGiven: "Gold Bean Given",
    GiveGoldCoin: "Give+",
    InvitationLink: "Invitation link",
    ShareQR: "Share QR code",
    InviteCount: "Invitees",
    RevenueBeans: "Gold beans earned",
    InvitationDetails: "Invitation details",
    EarningsDetails: "Earnings details",
    NickNameLabel: "Nickname",
    SaveImage: "Save Image",
    QRScanHint: "Scan the QR code or use the invite link to join",
    ShareTagline: "Share & Chat & Live",
    GoldenBeanUnit: "beans",
    CommissionRate: "{rate}% commission",
  },

  userMisconduct: {
    title1: "Content Violation I",
    p1: "1.Display or Spread Restricted Content:",
    p2: "Includes sharing pornography, vulgarity, violence, or racist content through Rain Live's private messages, live streams, or other features.",
    p3: "2.Spread Hate Speech:",
    p4: "Prohibits hate speech targeting religion, race, politics, or national identity.",
    p5: "3.Promotion or Recruitment:",
    p6: "Prohibits inviting users to join other applications or platforms through live streams, private messages, or reviewed comments.",
    title2: "Consequences",
    p7: "Accounts, devices, or IP addresses involved in such violations may be banned.",

    title3: "Content Violation II",
    p8: "1.Sharing Private Information:",
    p9: "Prohibits sharing private information such as phone numbers, account IDs, Facebook accounts, or photos via Rain Live's live streams, comments, or private messages.",
    p10: "2.Account Misuse:",
    p11: "Prohibits providing, renting, or selling Rain Live accounts to others.",
    p12: "3.Using Private Information:",
    p13: "Prohibits using or sharing private information (photos, nicknames, etc.) without user consent for personal gain or malicious purposes.",
    title4: "Consequences",
    p14: "Violating users will be permanently banned.",
  },

  landingPage: {
    info1: "Rain Live Circle",
    info2: "Apl Internal Purchase",
    item1: "45K Reviews",
    item2: "Download",
    item3: "Level 3 3+",
    btn: "Download",
    title: "About Rain Live",
    content:
      "Rain Live is a heartwarming online live-streaming app for everyone, including voice, video, entertainment, and games. The platform gathers high-profile hosts and serves as a deep and content-rich live-streaming platform. Intense PK matches, endless events, cool gifts, and an imperial experience await.",
    tips: "Rain Live ranks first on the list of popular free social applications.",
  },

  equityLevel: {
    Experience: "Experience Points",
    Level: "Current Level",
    Berikutnya: "Distance to Next Level",
    title1: "Level Privileges",
    desc1:
      "The higher the level, the more prestigious the icon level, and the easier it is to gain users' favor.",
    title2: "How to Upgrade",
    desc2:
      "1、User level is determined by the amount of experience points earned from gift consumption.",
    desc3:
      "2、You can earn experience points by sending gifts daily to level up.",
    desc4:
      "3、Lucky gifts: For every 1 coin spent, you gain 1 experience point.",
    desc5:
      "4、Special effect gifts: For every 1 coin spent, you gain 10 experience points.",
    title3: "Level Privileges",
    desc6:
      "The higher the level, the more prestigious the icon level, and the easier it is to gain the favor of users.",
    title3: "How to Upgrade",
    desc7:
      "1、Host level is determined by the amount of experience points earned from receiving gifts.",
    desc8:
      "2、You can earn experience points by receiving gifts daily to level up.",

    title6: "User level",
    title7: "Level",
    title8: "Level badge",
    title9: "Host level",
    title10: "Total experience points",

    LevelDescription: "Level description",
    tabUser: "User",
    tabEx: "EX Coin",
    tabAnchor: "Host",
    titleOverview: "Wealth Level Overview",
    nickNameUser: "Username",
    nickNameAnchor: "Host Name",
    nickNameEx: "Username",
    exPrivilegeDesc:
      "The higher the level, the more prestigious the icon level, and the easier it is to gain users' favor.",
    exDesc1:
      "1. EX Coin level is determined by the experience points earned from gift consumption.",
    exDesc2:
      "2. You can earn experience points by sending gifts daily to level up.",
    exDesc3:
      "3. Lucky gifts: For every 1 coin spent, you gain 1 experience point.",
    exDesc4:
      "4. Special effect gifts: For every 1 coin spent, you gain 10 experience points.",
    anchorPrivilegeDesc:
      "The higher the level, the more prestigious the icon level, and the easier it is to gain users' favor.",
    anchorDesc1:
      "1. Host level is determined by the experience points earned from gifts you receive.",
    anchorDesc2:
      "2. You can earn experience points daily by receiving gifts to level up.",
  },

  applyJoin: {
    tips1: "Please enter your WhatsApp account",
    title2: "Photo requirements",
    tips2:
      "Please show your face and upper body, and pose with your hands in a cat-like manner",
    tips3:
      "The photo will be taken for the company is review purposes only, andthe authorities will keep it confidential.",
    tips4: "The photo must be of yourself.",
    title3: "Video Requirements",
    tops5: "The video must feature the person themselves.",
    tips6: "The video should be between 10 to 20 seconds in length.",
    status1: "Submit for review",
    status2: "Under review",
    status3: "Review successful",
    status4: "Review failed",
    LiveMode: "Live mode",
    Video: "Video",
    Voice: "Voice",

    MP4: "Please choose an MP4 format video",
    pngOrJpg: "Please upload a PNG or JPG format image",

    UploadingWait: "Uploading, please wait",
    CompleteInformation: "Please complete the information",
    TabPersonalStreamer: "Host Verification",
    TabJoinGuild: "Join a guild",
    faceVerifyTitle: "Face Verification",
    faceVerifyPending: "Pending verification",
    faceVerifyVerified: "Verified",
    faceVerifyError: "You have verified another account and cannot be verified",
    faceVerifyRequired: "Please complete face verification first",
    faceVerifyNotSupported:
      "Face verification is not supported in the current environment",
    faceVerifyStart: "Start",
    faceVerifyRetry: "Try again",
    faceVerifySuccess: "Verification successful",
    faceVerifyFail: "Verification failed",
  },

  cancelAccount: {
    title: "Apply for Account Deletion",
    tips: "The following information will be cleared and cannot be recovered:",
    p1: "Once the account is deleted, all information will be permanently removed (including followers, fans, etc.), and any purchased premium services will no longer be retained or transferable to other accounts (e.g., VIP, special ID, avatar frame, etc.).",
    p2: "Linked Facebook, Twitter, Apple, and Google accounts will be unlinked. After unlinking, you may re-register.",
    p3: "Information related to your host application will be unlinked, allowing you to bind it to another account. (If you are a live streaming host, your host information can be reverified for live streaming).",
    p4: "Upon account deletion, any remaining gold coins, diamonds, experience points, vehicles, nobles, and other earnings-related data will be cleared. Any resulting loss of benefits will be borne by the person initiating the account deletion.",
    p5: "If you are a guild leader, submitting an account deletion request will automatically dissolve the guild. (Once the guild is dissolved, it cannot be restored even if the deletion request is withdrawn). If you are a guild member, account deletion will automatically remove you from the guild (you may withdraw the deletion request within 15 days to recover).",
    p6: "If you are a family leader, you must disband or leave the family before submitting an account deletion request.",
    p7: "If you are a family member (not a family leader), submitting an account deletion request will immediately remove you from the family (reversing the deletion within the 15-day appeal period will not restore family membership).",
    p8: "After submitting the deletion request, there is a 15-day appeal period. Logging in during this period will automatically cancel the deletion. Once the appeal period expires, the account will be permanently deleted and cannot be recovered. If the account needs to be recovered due to unauthorized or accidental operations, please contact customer support to appeal. (Customer Support WhatsApp: +62 81188011180, or email: rainlive888@gmail.com).",
  },

  Proxy: {
    Hello: "Hello,",
    Welcome: "Welcome to Rain Chat!",
    Account: "Account",
    Pleaseenter: "Please enter",
    Password: "Password",
    Login: "Login",
    MyAgent: "My agent",
    Nickname: "Agency nickname",
    CoinBalance: "Agency coin balance",
    TransferRecord: "Transfer record",
    Recharge: "Recharge",
    ExchangeProxyCoin: "Exchange proxy coin",
    TransferInformation: "Please fill in transfer information",
    Reset: "Reset",
    RecipientID: "Recipient ID",
    RecipientNickname: "Recipient nickname",
    TransferAmount: "Transfer amount",
    TotalTransferAmount: "Total",
    Transfer: "Transfer",
    KindReminder: "Kind reminder",
    DoubleCheck: "Please double-check the information to ensure accuracy",
    SelectAmount: "Please select the amount to top up",
    SelectMonth: "Select month",
    Username: "Username",
    TransferTime: "Transfer time",
    AutoFill: "Auto-fill",
    Rechargeselection: "Recharge selection",
    ProxyCurrency: "Insufficient Agent Coins",
    PaymentAmount: "Payment amount",
    PleaseSelectAmount: "Please select the amount to top up",
    GoldExchangeTitle: "Exchange Gold Beans for Agent Coins",
    GoldBalanceLabel: "Gold Beans balance: ",
    InputGoldPlaceholder: "Enter gold beans",
    AvailableProxyCoin: "Agent coins available",
    GiftProxyCoin: "Bonus {amount} agent coins",
    GiftBonusPercent: "Bonus {bonus}%",
    Exchange: "Exchange",
    Tip: "Tip",
    ExchangeConfirmHtml:
      'You will use <span class="green">{gold}</span> gold beans to exchange for <span class="green">{coin}</span><br/>agent coins, with a bonus of <span class="orange">{gift}</span> agent coins.',
    ExchangeSuccessTitle: "Exchange successful",
    ExchangeSuccessText: "Agent coins have been credited, please check.",
    ExchangeFail: "Exchange failed",
    RequestFail: "Request failed",
  },

  bd: {
    incomeDetail: {
      title: "Income Details",
      lastWeekIncome: "Last Week Income",
      totalIncome: "Total Historical Income",
      guildId: "Guild ID",
      date: "Date",
      thisWeek: "This Week",
      lastWeek: "Last Week",
      beforeLastWeek: "Week Before Last",
      thisMonth: "This Month",
      lastMonth: "Last Month",
      summary: "Summary",
      guildName: "Guild Name",
      guildIncome: "Guild Income",
      effectiveLive: "Effective Live",
      myIncome: "My Income",
      noData: "No Data Available",
      searching: "Searching income data",
      showingSummary: "Showing summary data",
    },
    index: {
      title: "BD",
      guildCount: "Guild Count",
      weekEstimatedIncome: "This Week Estimated Income",
      lastWeekIncome: "Last Week Income",
      inviteCode: "Invitation Code",
      searchPlaceholder: "Please enter Guild ID",
      lastWeek: "Last Week",
      guildName: "Guild Name",
      guildId: "Guild ID",
      weekIncome: "Guild Weekly Income",
      myIncome: "My Income",
      effectiveLive: "Effective Live",
      bindDays: "Binding Days",
      copySuccess: "Invitation code copied",
      enterGuildId: "Please enter Guild ID",
      searchGuild: "Search Guild ID",
      search: "Search",
      summary: "Summary",
      selectWeek: "Select Week",
      loading: "Loading...",
      loadFailed: "Load failed",
      networkError: "Network error, please try again later",
    },
  },

  noble: {
    expireTime: "Expiration time",
    canReceive: "Can receive {coin} coins",
    receive: "Receive Now",
    received: "Already Received",
    becomeNoble: "Activate",
    totalCanGet: "Total can get {price}{totalCoin} coins",
    silver: "Silver",
    gold: "Gold",
    platinum: "Platinum",
    diamond: "Diamond",
    obsidian: "Obsidian",
    type: "Benefits",
    levelReward: "Description",
    dailyExCoin: "Free Ex-Coin",
    rechargeReward: "Top up",
    gameSupport: "Game",
    exclusiveDecoration: "Outfit",
    decoration: {
      profileCard: "Profile",
      bubble: "Bubble",
      vehicle: "Vehicle",
      avatarFrame: "Avatar Frame",
      badge: "Badge",
    },
    dailyFreeExCoin: "Free {amount} Ex-Coin Daily",
    monthlyRechargeBenefit:
      "{percent}% monthly recharge as benefit fund, credited next month.",
    monthlyGameConsumptionBenefit:
      "{percent}% monthly gold coin consumption, credited next month.",
    privileges: {
      getCoin: "Get Coins",
      avatarFrame: "Avatar Frame",
      medal: "Medal",
      vehicle: "Vehicle",
      purchaseNotification: "Purchase Notification",
      chatBubble: "Chat Bubble",
      colorfulNickname: "Colorful Nickname",
      specialId: "Special ID",
      mystery: "Mystery Person",
      exclusiveService: "Exclusive Service",
      title: "Exclusive Privileges",
      Effect: "Room Entry Effect",
    },
    receiveSuccess: "Received Successfully",
    contactOperation: "Please contact operations to obtain",

    level1Recharge: " Silver VIP / 30 Days",
    level2Recharge: "Gold VIP / 30 Days",
    level3Recharge: "Platinum VIP / 30 Days",
    level4Recharge: "Diamond VIP / 30 Days",
    level5Recharge: "Black VIP / 30 Days",
    vipCenterTitle: "VIP Center",
    expireTimeText: "Expires",
    openVip: "Recharge to Open",
    reachedLevel: "Level Reached",
    stillNeedCoins: "Need {amount} more coins",
    stillNeedCoinsToKeepGrade: "Need {amount} more coins to keep grade",
    stillNeedCoinsToActivate:
      "Need {amount} more coins to activate {levelName}",
    keepGradeCompleted: "Renewal",
    keepGradeProgress: "Grade Keeping Progress: ",
    progress: "Progress",
  },

  bonusActivity: {
    title: "Live Streaming Bonus Activity",
    activityTime: "Activity Period: Apr 7 00:00 - May 4 23:59:59(UTC+8)",
    rewardRules: "Reward Rules",
    reward: "Rewards",
    totalReceived: "Total Received",
    bonus: "Bonus",
    claim: "Claim",
    claimed: "Claimed",
    notAchieved: "Not Achieved",
    duration: "Duration(Hours)",
    target: "Target(Coins)",
    note: "Note: After reaching the target, the bonus can be claimed the next day",
    activityCalendar: "Activity Calendar",
    april: "April",
    may: "May",
    claimSuccess: "Claimed Successfully",
  },

  bonusActivityRule: {
    activityDescription: "Activity Description",
    descriptionContent:
      "In addition to the basic rewards, hosts will receive extra bonuses from Rain Live.",
    activityTime: "Activity Period",
    timeContent1: "April 7, 2025 to May 4, 2025 (UTC+8)",
    timeContent2:
      "At 0:00 (UTC+8) every day, the next day's rewards will be activated",
    claimMethod: "Claim Method",
    claimContent:
      "When the target is achieved on the current day, rewards can be manually claimed the next day.",
    rewardTable: "Reward Table:",
    targetTurnover: "Target Turnover",
    activityReward: "Activity Reward",
  },

  inviteFriends: {
    invitationEventTitle: "Invitation Event",
    inviteAndEarnRewards: "Invite & Earn Rewards",
    eventPeriod: "Event Period: April 7 00:00 - May 4 23:59:59 (UTC+8)",
    invitationRecord: "Invitation Record",
    eventDetails: "Event Details",
    week1DateRange: "Week 1: April 7 - April 13",
    totalInvitedExample: "Total Invited",
    level1RewardText: "Lv.1 Invite 20 people 20000 Coins",
    level2RewardText: "Lv.2 Invite 50 people 50000 Coins",
    level3RewardText: "Lv.3 Invite 100 people 100000 Coins",
    statusClaimed: "Claimed",
    actionClaim: "Claim",
    statusNotAchieved: "Not Achieved",
    topUpRewardsLabel: "Top-Up Rewards:",
    copyInvitationLink: "Copy Invitation Link",
    rewardNote:
      "Note: When the invited user top-ups, you will receive 2% of the corresponding coins as a reward.",
    copySuccess: "Copy Successful",
    claimSuccessExample: "Successfully Claimed 20000 Coins",
    userIDLabel: "User ID",
    userNameLabel: "User Name",
    timeLabel: "Time",
    topUpLabel: "Top-Up",
    eventPurposeTitle: "【Event Purpose】",
    eventPurposeDesc:
      'To thank users for their long-term support and love for Rain Live, the platform is launching the "Invite Friends & Enjoy Multiple Rewards" event. We sincerely invite you and your friends to enjoy an exciting live streaming experience together!',
    eventDurationTitle: "【Event Duration】",
    eventDateRange: "April 7, 2025 – May 2025",
    eventCycleDesc:
      "A total of 4 weeks, with new rewards starting every Monday at 00:00 (UTC+8).",
    rewardRulesTitle: "【Reward Rules】",
    rewardRulesDesc1:
      "In addition to this event's rewards, you will continue to enjoy the original invitation bonus:",
    rewardRulesDesc2:
      "2% of the invited user's top-up coins will be rewarded to the inviter.",
    importantNotesTitle: "【Important Notes】",
    importantNotesDesc:
      "⚠️ Using fake accounts, bot registrations, or other malicious actions to obtain rewards is strictly prohibited. If detected, all rewards will be revoked immediately, and account restrictions may be applied.",
  },
  bonusPoints: {
    activityTime: "Event Time：",
    resetTime: "Resets daily at 0:00 (UTC+8)",
    pointsReward: "Points Reward",
    coinsReward: "Coins Reward",
    participationTimes: "Participation Count:{times}times",
    points: "Points",
    exchange: "Redeem",
    pointsMall: "Points Mall",
    note: "Note",
    rule1: "1.Points are earned by completing daily tasks.",
    rule2: "2.Rewards in the points mall change irregularly.",
    rule3: "3.Redeemed points are non-refundable. Redeem carefully.",
    coins: "Gold Coin",
    claim: "Claim",
    claimed: "Claimed",
    notAchieved: "Not Achieved",
    reach: "reach",
  },
  gameRanking: {
    notRanked: "Not Ranked",
    distanceToRank: "{points} points away from rank 50",
    distanceToBeforeRank: "{points} points away from rank {rankId}",
    rank1: "You are already in first place",
    today: "Today",
    yesterday: "Yesterday",
    ruleBtn: "Rule",
    rules: {
      pointsStats: {
        title: "Rules for Points Statistics",
        conversion:
          "1. Points Conversion Standard：1 gold coin is equivalent to 1 point in the event, and participants' points will be calculated directly based on the number of gold coins.",
        timeRange:
          "2. Statistics Time Range：The daily points statistics period is 00:00 to 23:59 (UTC+8 Time Zone), and gold coin data beyond this time period will be included in the next day's statistics.",
      },
      ranking: {
        title: "Ranking and Reward Rules",
        basis:
          "3. Ranking Basis：The system will rank participants in descending order based on their daily final points (i.e., the total number of gold coins that day) to determine the daily ranking.",
        rewards: "4. Reward Settings：",
        reward1: "Rank 1: Reward of 250,000 gold coins",
        reward2: "Rank 2: Reward of 150,000 gold coins",
        reward3: "Rank 3: Reward of 100,000 gold coins",
        reward4: "Rank 4: Reward of 50,000 gold coins",
        reward5: "Rank 5: Reward of 50,000 gold coins",
      },
      distribution: {
        title: "Reward Distribution Rules",
        description:
          "The rewards corresponding to the daily ranking will be distributed uniformly on the next day. Participants can log in to the event page or their personal account on the next day to check the reward receipt status.",
      },
      pointsCalculation: {
        description:
          "A minimum Game turnover of 5,000,000 is required to be eligible for the event rewards.",
      },
      helpReward: {
        description:
          "Help Reward: If the corresponding requirements are met but the ranking reward is not claimed, the help reward will be obtained.",
      },
      turnoverRewards: {
        title: "Turnover Reward Rules",
        turnover: "Turnover",
        reward: "Reward",
        turnover1M: "1,000,000",
        reward10K: "10,000 Gold Coins",
        turnover3M: "3,000,000",
        reward30K: "30,000 Gold Coins",
        turnover5M: "5,000,000",
        reward50K: "50,000 Gold Coins",
      },
      violation: {
        title: "Violation and Penalty Rules",
        description:
          "During the event, participants are strictly prohibited from using system vulnerabilities, plug-ins, or any other means to cheat by brushing points (gold coins). If found:",
        penalty1:
          "5. First-time violators will have their qualification for the day's reward revoked;",
        penalty2:
          "6. Violators with serious circumstances or repeated violations will be directly banned from participating in this event and subsequent related events, and the participation right will not be restored.",
      },
    },
  },
  luckyAnchorRanking: {
    today: "Today",
    yesterday: "Yesterday",
    notRanked: "Not ranked",
    distanceToRank: "Need {points} more lucky beans to reach top 50",
    distanceToBeforeRank:
      "Need {points} more lucky beans to reach rank {rankId}",
    rank1: "You are already rank 1",
    rules: {
      activity: {
        title: "Activity Description",
        description:
          "Count the daily lucky bean income of anchors and rank them based on this income.",
      },
      ranking: {
        title: "Ranking Rewards",
        rank: "Rank",
        reward: "Reward Beans",
        decoration: "Decoration",
        frameAndBubble: "Avatar Frame + Bubble",
        frameOnly: "Avatar Frame",
        requirement:
          "Minimum requirement for ranking rewards: 150,000 lucky bean income.",
      },
      helpReward: {
        title: "Support Rewards",
        description:
          "Users who do not receive ranking rewards can also get lucky bean income target rewards.",
        target: "Target",
        reward: "Reward",
      },
      distribution: {
        title: "Reward Distribution",
        description: "Rewards will be distributed the next day.",
      },
      statistics: {
        title: "Statistics Description",
        description: "The statistics are based on lucky bean income.",
      },
    },
  },

  // Red Envelope Rain Activity
  redEnvelopeRain: {
    countdownTitle: "Countdown to Grab Coins",
    startNow: "Start Now",
    rules: "Rules",
    timeSlotPrize: "Prize draw time",
    winningDetails: "Winning Details",
    activityRules: "Activity Rules",
    congratulations: "You Won!",
    sorryNoWin: "Sorry, you didn't win!",
    coin: "Coins",
    rulesContent: {
      rule1: "1.Activity Time: September 26 ~ October 15",
      rule2:
        "2.Activity Rules: Before each red envelope opens, complete 3 messages in the live streaming room to receive the red envelope.",
      rule3:
        "3.Every day from 20:00 to 00:40, red envelopes can be claimed every 20 minutes.",
      rule4: "4.You can participate repeatedly in different time slots",
      rule5:
        "5.The coins you receive will be distributed to your account in real-time",
    },
    timeStatus: {
      inProgress: "In Progress",
      notStarted: "Not Started",
      finished: "Finished",
    },
    chatRequirement:
      "Send 3 messages in live room to claim, current messages: {count}",
  },

  // Guild Activity
  guildActivity: {
    ruleBtn: "Rule",
    tabThis: "THIS",
    tabLast: "LAST",
    activityRules: "Activity Rules",
    rulesContent: {
      activityTime: "Activity Time: Starting September 29",
      rankingRewards: "Ranking Rewards",
      requirements: "Requirements",
      rewardDistribution: "Reward Distribution",
      rewardList: {
        first: "1st Place: 1,000,000 Gold Beans",
        second: "2nd Place: 500,000 Gold Beans",
        thirdToFifth: "3rd-5th Place: 250,000 Gold Beans",
        sixthToTenth: "6th-10th Place: 100,000 Gold Beans",
        eleventhToTwentieth: "11th-20th Place: 50,000 Gold Beans",
      },
      requirementText:
        "Guild hosts must complete at least 30 live streams per week. Each host's daily live stream over 2 hours counts as one session",
      distributionText: "Rewards will be distributed in the second week",
    },
  },

  // Charm/Consumption Ranking
  charmRanking: {
    charmRanking: "Charm Ranking",
    consumptionRanking: "Consumption Ranking",
    dailyRanking: "Daily Ranking",
    weeklyRanking: "Weekly Ranking",
    userNickname: "User Nickname",
    distanceToPrevious: "Previous",
    noRankingData: "No Ranking Data",
    requestFailed: "Request Failed",
  },

  // Invite Activity
  inviteActivity: {
    title: "Invite 3 People Get Rewards",
    rule: "Rule",
    alreadyJoined: "Already Joined",
    inviteImmediately: "Invite Now",
    callNumber: "Invite",
    myRewards: "My Rewards",
    claim: "Claim",
    claimed: "Claimed",
    people: "People",
    inviteFriends: "Invite Friends",
    processTitle: "Invitation Process:",
    step1: "1.Send link to friends",
    step2: "2.Friends download and register",
    step3: "3.Get free coins",
    rulesTitle: "Invitation Rules",
    rulesContent: {
      rule1: "When 3 people are invited, you can claim 16666 gold beans",
      rule2:
        "When 25 people are invited, you can claim another 36666 gold beans",
      rule3:
        "When 100 people are invited, you can claim another 88888 gold beans. Total claimable: 142220 gold beans.",
      rule4: "Rewards are manually claimed on the activity page.",
      rule5:
        "Malicious manipulation of invitation numbers is strictly prohibited. Account suspension will be enforced if detected",
    },
    close: "Close",
    inviteFeatureComingSoon: "Invite feature coming soon",
    rewardReceived: "Successfully received {amount} coins!",
  },

  // Gift Gold Coins Page
  giftGoldCoins: {
    maxGiftableCoins: "Maximum Giftable Coins",
    giftAmount: "Gift Coin Amount",
    customAmount: "Custom Gift Coin Amount",
    enterAmount: "Enter amount",
    quantity: "Quantity",
    giftToOtherAccounts: "Gift to Other Accounts",
    exceedMaxAmount: "Amount cannot exceed maximum giftable amount",
    amountSet: "Amount set successfully",
    invalidAmount: "Please enter a valid amount",
    selectValidAmount: "Please select a valid amount",
    confirmTitle: "Confirm Gift",
    confirmMessage: "Are you sure you want to gift {amount} coins?",
    giftSuccess: "Gift Successful",
    giftId: "Gift ID",
    enterGiftId: "Please enter ID",
    pleaseEnterGiftId: "Please enter gift ID",
    giftCompleted: "Gift completed!",
    giftedToId: "Gifted to ID",
    networkError: "Network error, please try again later",
    confirm: "Confirm",
  },

  // Decoration Shop
  shop: {
    headerTitle: "Personal Decoration",
    back: "Back",
    shoppingBag: "Shopping Bag",
    loading: "Loading...",
    noProducts: "No Products",
    unnamedProduct: "Unnamed Product",
    day: "Day",
    myCoins: "My Coins",
    exchangeNow: "Exchange Now",
    notSelected: "Not Selected",
    loginExpired: "Login expired, please login again",
    categoryNotExists: "Category does not exist",
    loadFailed: "Load Failed",
    loadFailedRetry: "Load failed, please try again",
    pleaseSelectProduct: "Please select a product first",
    productNotExists: "Product does not exist",
    insufficientCoins: "Insufficient coins, need {amount} coins",
    exchangeSuccess: "Exchange Successful",
    exchangeFailed: "Exchange Failed",
    categories: {
      hot: "Hot",
      avatarFrame: "Frame",
      entryEffect: "Entry Effect",
      chatBubble: "Bubble",
      mount: "Vehicle",
    },
    recharge: "Recharge >",
    validityPeriod: "Validity Period:",
    myCoinsLabel: "My Coins:",
  },
  myDecoration: {
    headerTitle: "My Decoration",
    back: "Back",
    noWearingDecoration: "No selected decoration",
    loading: "Loading...",
    noDecoration: "No Decoration",
    unnamedDecoration: "Unnamed Decoration",
    permanent: "Permanent",
    wearing: "Wearing",
    pleaseSelectDecoration: "Please Select Decoration",
    removeDecoration: "Remove Decoration",
    wearNow: "Wear Now",
    pleaseSelectDecorationFirst: "Please select a decoration first",
    decorationNotExists: "Decoration does not exist",
    loginExpired: "Login expired, please login again",
    loadFailed: "Load Failed",
    loadFailedRetry: "Load failed, please try again",
    wearSuccess: "Wear Successful",
    wearFailed: "Wear Failed",
    previewAnimation: "Preview",
    categories: {
      hot: "Hot",
      avatarFrame: "Frame",
      entryEffect: "Entry Effect",
      chatBubble: "Bubble",
      mount: "Vehicle",
    },
  },
  // Christmas Activity/Lucky Star Activity
  christmasActivity: {
    dailyLuckyStar: "Daily Lucky Star",
    weeklyLuckyStar: "Weekly Lucky Star",
    startTime: "Start time:",
    obtainedCount: "Obtained Count",
    moreChance: "More gifts, more chances",
    participated: "Met",
    notParticipated: "Unmet",
    historyRecord: "History Record",
    myRecord: "My Record",
    noRecord: "No Record",
    loading: "Loading...",
    noMore: "No More",
    coin: "Coins",
    goldCoin: "Golden Beans",
    unit: "pcs",
    notWon: "Not Won",
    conditionNotMet: "Condition not met",
    claimSuccess: "Claim successful",
    getRecordFailed: "Failed to get record",
    rules: {
      title: "Activity Rules",
      rule1: "Daily Lucky Star",
      rule2: "Daily Lucky Star event, all users can participate.",
      rule3:
        "When giving corresponding gifts to hosts, the number of gifts will be accumulated. When the number of gifts given meets the requirements, users can participate in the red packet opening, and each opening will have a lucky user receiving coin rewards.",
      rule4: "The more gifts given, the higher the chance of winning",
      rule5: "Weekly Lucky Star",
      rule6: "Weekly Lucky Star event, all hosts can participate.",
      rule7:
        "When receiving corresponding gifts from users, the number of gifts will be accumulated. When the number of gifts received meets the requirements, hosts can participate in the Weekly Lucky Star red packet opening, and each opening will have a lucky host receiving rewards.",
      rule8: "The more gifts received, the higher the chance of winning",
      rule9: "Other Notes",
      rule10: "This event is a big welfare appreciation program.",
      rule11: "Only applies to accumulation when giving gifts to other hosts.",
      rule12: "Strictly prohibited to use bugs/exploits to gain benefits.",
      rule13:
        "Rewards for each time period will be automatically distributed. You can check the winning records to understand the winning situation.",
    },
  },

  // Fortune Star Points Ranking Activity
  fortuneStarActivity: {
    points: "Point",
    pointsRanking: "Points Ranking",
    currentRoundPoints: "This",
    lastRoundPoints: "Last",
    defaultUserName: "User Name",
    noData: "No Data",
    activityRules: "Rules",
    historyRecord: "History",
    earnedPoints: "Earned Points",
    participated: "Participated",
    notParticipated: "Not Met",
    myRecord: "My Record",
    userId: "ID",
    userNickname: "Name",
    sessionTime: "Time",
    winningStatus: "Winning Status",
    won: "Won",
    notWon: "Not Won",
    rules: {
      rule1:
        "During the event, users can earn points by sending specified gifts",
      rule2:
        "Points are accumulated in real-time, check the current points ranking",
      rule3:
        "After the event ends, top-ranked users will receive generous rewards",
      rule4: "Cheating is strictly prohibited, violators will be disqualified",
      rule5: "The platform reserves the right of final interpretation",
    },
  },

  // Blind Box Activity
  blindBox: {
    title: "Gameplay Introduction",
    ruleTitle: "Gameplay Introduction",
    rule1:
      "Every {price} gold coins unlock one {text}. Upon opening, you'll get random gifts that are automatically added to your backpack.",
    rule2:
      "Gifts obtained can be sent from your backpack to your desired streamer, who will receive the corresponding gold beans in return.",
    rewardTip: "Reward Tips",
    probabilityDesc: "The specific probability is as follows:",
    prize: "Prize",
    probability: "Probability",
    value: "Value",
  },

  taskHub: {
    tabCenter: "Task Center",
    tabAnchor: "Host Tasks",
    signTitle: "7-day Check-in",
    signStreakBefore: "Consecutive check-in ",
    signStreakAfter: " days",
    signBtn: "Check in",
    signBtnDone: "Checked in",
    signPeriod: "This period: {start} - {end}",
    dayLabel: "Day{n}",
    avatarFrame: "Avatar frame",
    activeTasks: "User activity tasks",
    timeLeft: "Time left: {t}",
    claimable: "Claim",
    inProgress: "In progress",
    rewardGain: "Earn {n} EX coins",
    taskWatchLive: "Watch live for 30 minutes",
    taskFollowHosts: "Follow 3 hosts",
    taskSpeakRooms: "Speak 3 times in different rooms",
    taskGiftCoins: "Spend 100 coins on gifts",
    taskGameCoins: "Spend 100 coins on games",
    taskRechargeToday: "Recharge once today",
    unitMinutes: " min",
    unitHosts: " hosts",
    unitTimes: " times",
    unitCoins: " coins",
    unitDays: " days",
    toastSigned: "Checked in",
    toastClaimed: "Claimed",
    claimSuccessTitle: "Claim Successful",
    claimSuccessOk: "Got it",
    toastInProgress: "Task in progress",
    toastLoadFail: "Failed to load",
    claimed: "Completed",
    toastRefreshed: "Refreshed",
    anchorActivity: "Activity",
    weekDurationTitle: "Weekly duration",
    activityPeriod: "Activity period",
    weekLiveDuration: "Live duration this week",
    weekRank: "Weekly rank",
    claimableReward: "Claimable reward",
    effectExtraTitle: "Special effect bonus",
    effectBeansToday: "Effect beans received today",
    rewardDate: "Reward date {date}",
    claimableAmount: "Claimable",
    claimNow: "Claim now",
    claimedToday: "Claimed today:",
    effectNote: "Note: claim today's rewards before 1:00 (UTC+8) the next day.",
    todayData: "Today Data",
    todayLiveDuration: "Today's live duration",
    liveHintShort: "{remain} left",
    needMoreBeans: "{n} more needed",
    toastNoClaimable: "No reward available to claim",
    toastClaimPending: "Claim API pending integration",
    luckyBeans: "Lucky beans",
    nextDayLucky: "Next-day lucky reward",
    upgradeBeansTitle: "Upgrade to claim beans",
    upgradeReward: "Upgrade reward",
    weekData: "Week Data",
    totalLiveDuration: "Total live duration",
    validDays: "Valid days",
    weekLuckyReward: "Weekly lucky reward",
    dayDataTitle: "Today Data",
    monthDataTitle: "Month Data",
    weekDataTitle: "Week Data",
    monthLiveDuration: "Monthly live duration",
    weekLiveDuration: "Weekly live duration",
    specialBeans: "Special beans",
    totalBeans: "Total beans",
  },

  pcOfficial: {
    navHome: "Home",
    navLive: "Live",
    navGameHall: "Game Hall",
    received: "received",
    heroTagline: "A Leading Web4 Entertainment Platform",
    heroTaglineSub:
      "24/7 real-time interaction with top hosts and premium blockchain gaming. Powered by decentralization for instant rewards and fair play.",
    downloadNow: "Download Now",
    giftCoin: "EX Coin",
    giftAvatarFrame: "Avatar Frame",
    bottomDownloadAndroidApk: "Android APK",
    recommendTitle: "Featured Hosts",
    recommendSub:
      "Interact with thousands of top hosts in real time and enjoy P2E gaming",
    hotGamingTitle: "Hot Gaming",
    hotGamingSub: "Real players, real rankings. Will you be the next legend?",
    casinoTitle: "Casino",
    casinoDesc1: "Join live dealers for Baccarat,",
    casinoDesc2: "Roulette, and Blackjack in HD",
    slotsTitle: "Slots",
    slotsDesc: "Spin through premium slot games with 98.5% RTP",
    gamingTitle: "Gaming",
    gamingDesc: "Beyond the reels, dive into multiplayer skill games",
    whyTitle: "Why Rain Live",
    whyItem1Title: "Fair & Just",
    whyItem1Desc: "Audited RNG ensures provably fair gameplay",
    whyItem2Title: "Instant Payout",
    whyItem2Desc: "Fast withdrawals with instant settlement",
    whyItem3Title: "Anonymous & Private",
    whyItem3Desc: "100% private with no personal information required",
    whyItem4Title: "Decentralized",
    whyItem4Desc: "Secure and transparent on-chain gaming",
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    navRecharge: "Recharge",
    rechargeAccountTitle: "Recharge account",
    idLogin: "ID login",
    accountIdLabel: "Account ID:",
    accountIdPlaceholder: "Enter account ID",
    confirm: "Confirm",
    defaultUserName: "Username",
    userIdWithValue: "ID:{id}",
    switchAccount: "Switch account",
    rechargeQuantityTitle: "Amount",
    goToPay: "Continue to pay",
    topUpAmountTitle: "Top-up amount",
    pay: "Pay",
    channelDefault: "Channel",
    toastInvalidAccountId: "Please enter a valid account ID",
    toastNoTokenAfterLogin: "Login succeeded but token was not returned",
    toastLoginFailed: "Login failed",
    toastCoinPackagesFailed: "Failed to load coin packages",
    toastPayChannelsFailed: "Failed to load payment channels",
    toastOrderParamsMissing: "Missing order parameters",
    toastNoPayUrl: "Payment URL not found",
    toastCreateOrderFailed: "Failed to create payment order",
    rainLiveRecharge: "Rain Live Recharge",
    selectCountryTitle: "Select country / region",
    selectChannelTitle: "Select payment method",
    rechargeLoading: "Loading...",
    rechargePackagesEmpty: "No recharge packages available",
    rechargeLoginHint: "Please sign in with your ID first",
  },

  rainChatOfficial: {
    navHome: "Home",
    navContact: "Contact Us",
    navRecharge: "Recharge",
    heroSub:
      "On RainChat, share life's moments, meet interesting people, and enjoy a new experience of video, voice chat, and live interaction.",
    feature1Title: "Feed Sharing",
    feature1Desc:
      "Share life moments and discover the beauty and warmth of the world",
    feature2Title: "Video Live",
    feature2Desc:
      "Go live anytime, anywhere, interact with viewers in real time, and share exciting moments",
    feature3Title: "Voice Live",
    feature3Desc:
      "Convey charm with your voice — voice live makes communication more direct and warm",
    feature4Title: "Video & Voice Chat",
    feature4Desc:
      "One-on-one or group chat with HD video and voice for more authentic communication",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    copyright: "©2026 RainChat. PT SEJAHTERA GROUP INDONESIA.",
    contactEmailLabel: "Email",
    contactHint:
      "If you have any questions or partnership inquiries, feel free to contact us by email.",
    linkNotReady: "Download link is not available yet",
    appNotDetected: "App not detected. Please download it.",
    appStore: "App Store",
    googlePlay: "Google Play",
    android: "Android",
    downloadBtn: "Download",
    coinRechargeTitle: "Coin Recharge",
    packageBonus: "Extra +{count} coins",
  },

  // Live duration reward activity
  liveDuration: {
    tabthisWeek: "This  Week",
    tablastWeek: " Last Week",
    eventTime: "Event Time: {time}",
    rewardCoin: "Reward Coins",
    liveHours: "Live Duration",
    myRank: "My Rank",
    zeroHours: "0h",
    hoursOnly: "{hours}h",
    minutesOnly: "{minutes}m",
    hoursMinutes: "{hours}h {minutes}m",
  },

  // USDT recharge order payment page
  topUpUsdt: {
    orderNo: "Order No.",
    copy: "Copy",
    copyOrderNo: "Copy order number",
    copyAddress: "Copy receiving address",
    productName: "RainChat GoldCoin",
    quantityUnit: "× {count}",
    orderAmount: "Order amount",
    scanToPay: "Scan to pay",
    scanTip: "Scan the QR code with your wallet app to pay",
    qrAreaAlt: "Payment QR code area",
    qrCodeAlt: "Payment QR code",
    receivingAddress: "Receiving address",
    validityPrefix: "Valid for",
    validityMinutes: "{minutes} min",
    validitySuffix: ", please pay soon",
    orderNoCopied: "Order number copied",
    addressCopied: "Receiving address copied",
    nothingToCopy: "Nothing to copy",
    copyFailed: "Copy failed, please copy manually",
    promptTitle: "Tip",
    rechargePrompt: "If you have recharged, please tap Complete Recharge",
    cancel: "Cancel",
    completeRecharge: "Complete Recharge",
    rechargeCompleted: "✔ Recharge completed",
    rechargeCompletedText: "Recharge completed",
    rechargePending:
      "The payment has not arrived yet. There may be a delay. Coins will be added automatically after arrival.",
    gotIt: "Got it",
  },

  // Experience Coin Lucky Turntable Activity
  luckyTurntable: {
    draw: "Draw",
    drawing: "Drawing",
    task: "Task",
    recharge: "Recharge",
    historyRecord: "History Record",
    balanceLabel: "Experience Coin Balance: ",
    exGradeTip: "Ex Level Lv.{grade} · Requires Lv.{level} to participate",
    got: "got",
    defaultNotice: "User Nickname {got} Experience Coin",
    insufficientBalance: "Insufficient balance",
    exGradeNotMet: "Ex level not met",
    configLoadFailed: "Failed to load config, please try again later",
    recordLoadFailed: "Failed to load records, please try again later",
    drawResultError: "Draw result error, please try again later",
    drawFailed: "Draw failed, please try again later",
    winTitle: "Congratulations! You got",
    winConfirm: "Got it",
    loading: "Loading...",
    noRecord: "No records",
    noMore: "No more",
  },

  rewardActivity: {
    moreReward: "More",
    tabInvite: "Invite Active",
    tabWelfare: "7-Day Bonus",
    tabMic: "On-Mic Reward",
    inviteTitle: "Invite Active Rewards",
    yesterdayData: "Yesterday",
    yesterdayActive: "Active invitees",
    goldBean: "Beans",
    todayDataRealtime: "Today (live)",
    todayActive: "Active invitees",
    peopleUnit: "",
    estimateReward: "Est. reward",
    claimTomorrowTip: "Claimable at 10:00 next day",
    claimAt10: "Claim at 10:00",
    claimYesterday: "Claim yesterday reward",
    claimed: "Claimed",
    noReward: "No reward",
    viewDetail: "View details",
    welfareTitle: "New Host 7-Day Bonus",
    personalNewHost: "Personal new host",
    rule: "Rules",
    welfareRemain: "Bonus time left",
    dayUnit: "days",
    minuteUnit: "min",
    day1: "Day 1",
    day7: "Day 7",
    todayData: "Today",
    todayMicDuration: "On-mic time today",
    claimableBean: "Claimable beans",
    claimReward: "Claim reward",
    claimTodayReward: "Claim today's reward",
    todayCanClaim: "Still {amount} today",
    needMic60: "Stay on mic 60 minutes today to claim",
    needMic120: "Stay on mic 120 minutes today to claim",
    todayClaimedAll: "Today's rewards claimed",
    becomeAnchor: "Become a host to claim",
    totalClaimed: "Total claimed beans",
    welfareRulesTitle: "7-Day Benefit Rules",
    welfareCondTitle: "1. Participation Requirements:",
    welfareCond1: "a. New users within 7 days of registration",
    welfareCond2: "b. Completed Host verification",
    welfareCond3: "c. Not joined any Agency",
    welfareRewardTitle: "2. Reward Details",
    welfareReward1:
      "a. Going on-mic and unmuting daily accumulates your on-mic time.",
    welfareReward2: "b. For every 1 hour, you can claim 5,000 Gold Beans.",
    welfareReward3:
      "c. You can claim up to 2 hours and 10,000 Gold Beans per day.",
    welfareReward4: "d. You can claim up to 70,000 Gold Beans in total.",
    welfareNoteTitle: "3. Notes",
    welfareNote1: "a. Rewards must be claimed manually every day",
    welfareNote2:
      "b. If you have been registered for more than 7 days, you can no longer claim.",
    welfareNote3: "c. Data is updated every 10-15 minutes",
    welfareNote4:
      "d. If unfair methods are found to be used to farm rewards, the account will be banned.",
    micRulesTitle: "On-Mic Reward Rules",
    micCondTitle: "1. Participation Requirements:",
    micCond1: "a. Completed Host verification",
    micCond2: "b. Not joined any Agency.",
    micRewardTitle: "2. Rewards",
    micGradeLevel: "Level",
    micGradeIncome: "7-Day Gold Bean Earnings",
    micGradeHourly: "Hourly Rate (Gold Beans/h)",
    micGradeDaily: "Daily Limit",
    micGradeBeans: "{beans} Gold Beans ({usd})",
    micGradeDailyLimit: "2 hours",
    micExplainTitle: "3. Explanation",
    micExplain1:
      "a. RainChat will calculate your level based on your Gold Bean earnings over the last 7 days (current day + previous 6 days)",
    micExplain2: "b. Data is updated every 10-15 minutes.",
    micExplain3:
      "c. Based on your current level, you can claim the hourly Gold Bean reward corresponding to that level.",
    micExplain4:
      "d. Rewards are claimed manually and will be credited to your account in real time after claiming.",
    micExplain5:
      "e. If you do not claim the reward on the same day, it will expire.",
    micExplain6: "f. You can claim up to 2 hours of hourly reward per day.",
    micExplain7:
      "g. When your 7-day Gold Bean earnings exceed the SS cap, for every additional 700,000 Gold Beans, the hourly rate increases by 20,000.",
    micExplainExample: "Example: 7,700,000 Gold Beans, hourly rate of 220,000.",
    micExplain8:
      'h. While enjoying the "7-Day Benefit", the "Level I" hourly reward is unavailable. After the "7-Day Benefit" ends, you can claim it normally.',
    micExplain9:
      "i. If unfair methods are found to be used to farm rewards, the account will be banned.",
    nextRefresh: "Next refresh",
    recent7Days: "Last 7 days",
    micRangeTip: "Today + previous 6 days\nNeed to be a host",
    totalIncome: "Total income",
    upgradeDesc: "{remain} more to upgrade, bonus increases {bonus}",
    ssBonusDesc: "For every additional 700K Gold Beans, the bonus increases by 20K Gold Beans.",
    completeAllTask: "Complete all tasks to get",
    claim: "Claim",
    grantSuccess: "Reward sent",
    thisTimeGot: "You received",
    grantedToAccount: "The reward has been added to your account",
    gotIt: "Got it",
    claimFail: "Claim failed, please try again later",
    micTaskName: "Go live / on mic {minutes} min today",
  },
  guildApply: {
    "title": "Guild Application",
    "pendingCount": "{count} Pending",
    "autoApproveTip": "Over 7 days auto-approve. Review now",
    "joinRequest": "({rainId}) wants to join",
    "daysRemaining": "{days} days left",
    "appliedWithinOneDay": "Applied within 1 day",
    "appliedDaysAgo": "{days} days ago",
    "boundDays": "Bound: {days} days",
    "incomeTier": "Income tier: {level}",
    "applyToGuild": "Apply to Guild",
    "reject": "Reject",
    "approve": "Approve",
    "noPendingRequests": "No pending requests",
    "approved": "Approved",
    "rejected": "Rejected",
    "approvalConfirmTitle": "Notice",
    "approvalConfirmMessage": "Once approved, the user will join another guild and will no longer generate commission income for you.",
    "back": "Back",
    "pendingList": "Pending applications",
    "noToken": "Login token not found",
    "listLoadFailed": "Failed to load application list",
    "listLoadFailedRetry": "Failed to load application list, please try again later",
    "operationFailedRetry": "Operation failed, please try again later"
  },
  inviteFriendsNew: {
    "inviteRanking": "Invite Ranking",
    "messages": "Messages",
    "totalRewards": "Total Invite Rewards",
    "earnings": "Earnings",
    "totalValue": "Total Value",
    "viewDetails": "View Details",
    "inviteStats": "Invite Stats",
    "totalInvites": "Total",
    "todayInvites": "Today",
    "details": "Details",
    "inviteFriends": "Invite Friends",
    "copyLink": "Copy Link",
    "close": "Close",
    "saveImage": "Save Image",
    "inviteModal": "Invite friends modal",
    "rightTools": "Page entries",
    "noToken": "Login token not found",
    "rewardsLoadFailed": "Failed to load invite earnings",
    "rewardsLoadFailedRetry": "Failed to load invite earnings, please try again later",
    "inviteInfoLoadFailed": "Failed to load invite info",
    "inviteInfoLoadFailedRetry": "Failed to load invite info, please try again later",
    "linkNotReady": "Invite link is not ready yet",
    "linkCopied": "Invite link copied",
    "copyFailedRetry": "Copy failed, please try again later",
    "saveFailedRetry": "Failed to save image, please try again later"
  },
  inviteRanking: {
    "title": "Ranking",
    "earningsRank": "Earnings Rank",
    "inviteRank": "Invite Rank",
    "day": "Day",
    "week": "Week",
    "total": "Total",
    "people": "People",
    "noToken": "Login token not found",
    "loadFailed": "Failed to load ranking",
    "loadFailedRetry": "Failed to load ranking, please try again later"
  },
  inviterInformation: {
    "title": "My Invites",
    "earnings": "Earnings",
    "members": "Members",
    "filter": "Filter:",
    "earningsTrend": "Earnings Trend",
    "dailyInvites": "Daily Invites",
    "verifiedHost": "Verified Host",
    "inGuild": "In Guild",
    "contact": "Contact",
    "level1Earnings": "Level 1 Earnings",
    "level2Earnings": "Level 2 Earnings",
    "totalUsd": "Total (USD)",
    "loading": "Loading...",
    "noMore": "No More",
    "noData": "No Data",
    "back": "Back",
    "tabTypes": "Inviter information tabs",
    "dateFilter": "Date filter",
    "noToken": "Login token not found",
    "trendLoadFailed": "Failed to load trend data",
    "trendLoadFailedRetry": "Failed to load trend data, please try again later",
    "listLoadFailed": "Failed to load inviter list",
    "listLoadFailedRetry": "Failed to load inviter list, please try again later"
  },
  rewardSource: {
    "title": "Reward Details",
    "pleaseSelect": "Please Select",
    "activityEarnings": "Active",
    "rechargeEarnings": "Recharge",
    "gameCommission": "Game",
    "incomeCommission": "Income",
    "back": "Back"
  },
  rewardSourceRule: {
    "back": "Back",
    "active": {
      "title": "Invitation Activity Rules",
      "bindTitle": "How to bind a friend",
      "bindSteps": [
        "Step 1: Tap the Invite button at the bottom of the Invitation Activity page, then save the invitation image or copy your exclusive invitation link.",
        "Step 2: Send the saved image or exclusive invitation link to your friend.",
        "Step 3: Your friend must download and register through the QR code in the invitation image or through your exclusive invitation link. Once they complete the registration, they will be successfully bound to your account."
      ],
      "questionTitle": "Q: Why can't I bind my friend?",
      "answer": "A: Each mobile phone can only have one account bound to an inviter. Your friend may have already been bound to another account before.",
      "userTitle": "Active User Rules",
      "userIntro": "Friends you have successfully bound can increase your Active User Count by completing the daily activity tasks.",
      "tasks": [
        "Task 1: Join an audio room and stay on the mic with your microphone on for 2 hours.",
        "Task 2: Game valid bets hit 1,000 Coins.",
        "Verification is required.",
        "Completing any one of the above tasks will count as 1 Active User for you.",
        "Each friend can provide a maximum of 1 valid Active User Count per day."
      ],
      "userNotes": [
        "Each bound friend can provide valid Active User Counts only during the first 7 days after registration.",
        "Each bound friend can provide a maximum of 7 valid Active User Counts in total."
      ],
      "rewardTitle": "Active User Rewards",
      "rewardIntro": "When your daily Active User Count reaches the required amount, you can receive Bean rewards.",
      "rewardTableIntro": "The rewards are as follows:",
      "rewardTableLabel": "Active User Bean Reward Table",
      "rewardHeaders": ["Daily Active Users", "Bean Reward", "$"],
      "rewardNotes": [
        "You can earn a maximum of $70 worth of rewards per day.",
        "The previous day's reward will become available for manual collection at 10:00 AM the next day.",
        "Claim Location: Go to the Live tab or enter a livestream room and tap the floating “Rewards” button.",
        "Once the reward is issued, it must be claimed on the same day, otherwise it will expire. Please claim your rewards as soon as possible."
      ],
      "noticeTitle": "Important Notes",
      "notices": [
        "Each mobile phone can only have one account bound to an inviter.",
        "Bound friends must complete verification before they can be counted as Active Users.",
        "The list only displays users who registered within the past 7 days.",
        "If any improper methods are used to bind accounts or artificially increase the Active User Count, the platform will not issue the corresponding rewards. In serious cases, the account may also be banned or subject to other penalties."
      ]
    },
    "game": {
      "title": "Game Rebate Rate Level Rules",
      "levelTitle": "Game Rebate Rate Level System",
      "levelText": "Your level is determined by the total Game bets generated by your three-level team, including yourself, your tier 1 invite, and your tier 2 invite. The higher the bets, the higher your tier and the more commission you can earn.",
      "rewardTitle": "Reward Structure",
      "rewards": [
        "Tier 1 rebate rate: Earn rebate rate directly from the Game bets generated by your Tier 1 invite.",
        "Tier 2 rebate rate: If a Tier 1 invite has a lower level than you, you can earn additional rebate rate from the Game bets generated by their Tier 2 members."
      ],
      "tierTitle": "Game Rebate Rate Tier Table",
      "tierLabel": "Game Rebate Rate Tier Table",
      "tierHeaders": ["Level", "Total Team Game Bets (30 Days)", "Rebate Rate"],
      "tierNote": "Your tier will be determined based on your team's Game bets over the past 30 days.",
      "assessmentTitle": "Reward Distribution & Level Evaluation Rules",
      "assessments": [
        "At 00:00 every day, the system will calculate your team's Game bets from the previous 30 days and determine your level.",
        "Based on your evaluated level, the system will calculate and distribute your rewards for the previous day."
      ],
      "exampleTitle": "Simple Examples",
      "examples": [
        "If your level is Lv.5, you will receive 0.5% of the Game bets generated by your tier 1 members.",
        "If your level is Lv.5 and one of your Tier 1 invites is Lv.3, you will receive 0.2% of the Game bets generated by the Tier 2 invites brought in by this Tier 1 invite. This is because the difference between your rebate rates is 0.2% (0.5% - 0.3%).",
        "If your level is Lv.5 and one of your Tier 1 invites is also Lv.5, the Game bets generated by this Tier 1 invite's Tier 2 invites will not generate any additional reward for you, because the difference between your rebate rates is 0 (0.5% - 0.5%)."
      ],
      "detailTitle": "Detailed Diagram Explanation",
      "detailTeamTitle": "Team Level Calculation:",
      "detailTeams": [
        {
          "title": "A's Team",
          "lines": [
            "A's own bets + Tier 1 invite's bets + Tier 2 invite's bets.",
            "A + B + C + D + E + F + G = 10M + 20M + 10M + 5M + 800M + 200M + 10M = 1,055M",
            "Level: Lv.5",
            "Rebate Rate: 0.5%."
          ]
        },
        {
          "title": "B's Team (B is A's Tier 1 invite)",
          "lines": [
            "B + E + F = 20M + 800M + 200M = 1,020M",
            "Level: Lv.5",
            "Rebate Rate: 0.5%."
          ]
        },
        {
          "title": "C's Team (C is A's Tier 1 invite)",
          "lines": [
            "C + G = 10M + 10M = 20M.",
            "Level: Lv.2",
            "Rebate Rate: 0.2%."
          ]
        }
      ],
      "detailIncomeTitle": "A's Rebate:",
      "detailIncomeGroups": [
        {
          "title": "Direct Commission from tier 1 invite (B, C, D)",
          "plainLines": [
            "(B's own bets + C's own bets + D's own bets) × A's Rebate rate",
            "= (20M + 10M + 5M) × 0.5%",
            "= 35M × 0.5%",
            "= 175,000 Coins ($17.50)"
          ]
        },
        {
          "title": "indirect rebate from tier 2 invite (E, F, G)",
          "numberedItems": [
            {
              "title": "From E and F:",
              "plainLines": [
                "(A's Rebate rate - B's Rebate rate) × (E + F)",
                "= (0.5% - 0.5%) × (800M + 200M)",
                "= $0",
                "Because B's Rebate rate is the same as A's, the difference is 0, so A does not receive any additional rebate from E and F."
              ]
            },
            {
              "title": "From G:",
              "plainLines": [
                "(A's rebate rate - C's rebate rate) × G",
                "= (0.5% - 0.2%) × 10M",
                "= 0.3% × 10M",
                "= 30,000 Coins ($3.00)",
                "Because A's rebate rate is 0.3% higher than C's, A receives an additional 0.3% rebate from G's Game bets."
              ]
            }
          ]
        }
      ]
    },
    "income": {
      "title": "Income Rebate Tier System",
      "levelTitle": "Income Rebate Tier System",
      "levelText": "Your tier is determined by the total income generated by your three-level team, including yourself, your tier 1 inviter, and your tier 2 inviter. The higher your team's income, the higher your tier and the more you can earn.",
      "rewardTitle": "Reward Structure",
      "rewards": [
        "Your own income",
        "Income generated by your tier 1 inviter",
        "Income generated by your tier 2 inviter"
      ],
      "tierTitle": "Income Rebate Level Table",
      "tierLabel": "Income Rebate Level Table",
      "tierHeaders": ["Level", "Team Bean Income in the Past 30 Days", "Rebate Rate"],
      "tierNote": "Your level will be determined based on your team's total income over the past 30 days.",
      "sPlusTitle": "S+",
      "sPlus": [
        "If two of your tier 1 inviters reach S level, you will be upgraded to S+ level.",
        "You will receive a 21% rebate rate."
      ],
      "sPlusTierText": "Having 2 inviter hit S",
      "assessmentTitle": "Reward Distribution & Level Evaluation Rules",
      "assessments": [
        "At 00:00 every day, the system will calculate your team's income from the previous 30 days and determine your level.",
        "Your reward for the previous day will then be calculated based on your evaluated level."
      ],
      "exampleTitle": "Simple Examples",
      "examples": [
        "Example 1: If your level is S, you will receive 20% of your own Bean income as a reward.",
        "Example 2: If your level is S and your tier 1 inviter is A, you will receive a 2% Bean rebate from this tier 1 inviter's gift income and the gift income generated by their tier 2 inviter. This is because the difference between your rebate rates is 20% - 18% = 2%.",
        "Example 3: If your level is S and one of your tier 1 inviters is also S, you will not receive any additional income from this tier 1 inviter, because the difference between your rebate rates is 0%.",
        "Example 4: If you have two tier 1 inviters who are S level, you will be upgraded to S+ level, with a rebate rate of 21%. You can still receive a 1% rebate from their income because the difference between your rebate rate and theirs is 21% - 20% = 1%."
      ],
      "noticeTitle": "Important Notes",
      "notices": [
        "If a member of your team joins an agency, they will no longer generate income rebates for you. However, their income will still be included when calculating your team's total income and determining your rebate level.",
        "Your level is determined based on your team's Bean income from gifts over the past 30 days.",
        "You must complete host verification before your income can be included in the calculation."
      ],
      "detailTitle": "Detailed Diagram Explanation",
      "detailGroups": [
        {
          "title": "Team Level Calculation:",
          "items": [
            {
              "title": "A's Team",
              "points": [
                { "title": "A's income + B's income + C's income + D's income + E's income + F's income", "lines": [] },
                { "title": "20M + 156M + 98M + 40M + 4M + 2M = 320M", "lines": [] },
                { "title": "Level: S", "lines": [] },
                { "title": "Rebate Rate: 20%", "lines": [] }
              ]
            },
            {
              "title": "B's Team",
              "points": [
                { "title": "B's income + D's income + E's income", "lines": [] },
                { "title": "156M + 40M + 4M = 200M", "lines": [] },
                { "title": "Level: A", "lines": [] },
                { "title": "Rebate Rate: 18%", "lines": [] }
              ]
            },
            {
              "title": "C's Team",
              "points": [
                { "title": "C's income + F's income", "lines": [] },
                { "title": "98M + 2M = 100M", "lines": [] },
                { "title": "Level: A", "lines": [] },
                { "title": "Rebate Rate: 18%", "lines": [] }
              ]
            }
          ]
        },
        {
          "title": "Calculation of A's Income:",
          "items": [
            {
              "title": "Own Income",
              "points": [
                { "title": "A's income × A's rebate rate", "lines": [] },
                { "title": "20M × 20% = 4,000,000 Beans", "lines": [] }
              ]
            },
            {
              "title": "Tier 1 Inviter's Income",
              "points": [
                { "title": "Member B", "lines": ["B's income × (A's rebate rate - B's rebate rate)", "156M × (20% - 18%) = 3,120,000 Beans"] },
                { "title": "Member C", "lines": ["C's income × (A's rebate rate - C's rebate rate)", "98M × (20% - 18%) = 1,960,000 Beans"] }
              ]
            },
            {
              "title": "Tier 2 Inviter's Income",
              "points": [
                { "title": "Members D and E (B's members)", "lines": ["(D's income + E's income) × (A's rebate rate - B's rebate rate)", "(40M + 4M) × (20% - 18%) = 880,000 Beans"] },
                { "title": "Member F (C's member)", "lines": ["F's income × (A's rebate rate - C's rebate rate)", "2M × (20% - 18%) = 40,000 Beans"] }
              ]
            },
            {
              "title": "Total",
              "points": [
                { "title": "Own income: 4M Gold Beans", "lines": [] },
                { "title": "Tier difference rebate: 3.12M + 1.96M + 0.88M + 0.04M = 6M Beans", "lines": [] },
                { "title": "Total income: 10M Gold Beans", "lines": [] }
              ]
            }
          ]
        }
      ]
    },
    "recharge": {
      "title": "Recharge Reward Rules",
      "cashbackTitle": "Recharge Rebates",
      "cashback": [
        "For 30 days after your invited friend registers, their recharges will earn you a recharge rebate.",
        "If your invited friend invites another friend, that new user's recharges during their first 30 days after registration will also earn you a recharge rebate according to the referral relationship."
      ],
      "chainTitle": "Referral Relationship",
      "chainIntro": "As shown in the diagram:",
      "chainAlt": "Diagram of the A, B, C, D referral chain",
      "chainExamples": [
        "If B recharges 10,000 Coins, A will receive 200 Coins (2% rebate).",
        "If C recharges 10,000 Coins, B will receive 200 Coins (2% rebate), and A will receive 100 Coins (1% rebate).",
        "If D recharges 10,000 Coins, C will receive 200 Coins (2% rebate), B will receive 100 Coins (1% rebate), and A will no longer receive any rebate from D.",
        "Your direct referrals (1st level) will provide you with a 2% recharge rebate.",
        "Your indirect referrals (2nd level) will provide you with a 1% recharge rebate."
      ],
      "validityTitle": "30-Day Validity Period",
      "validity": [
        "All recharges made by an invited friend during the 30 days from their registration date will generate a rebate for their referrer.",
        "After the 30-day period ends, any subsequent recharges will no longer generate any recharge rebate."
      ],
      "payoutTitle": "Reward Distribution Rules",
      "payout": [
        "Once a user completes a recharge, the corresponding rebate will be credited to your wallet in real time.",
        "Supported recharge methods include direct coin purchases and coin seller recharges."
      ]
    }
  },
  rewardSourceDetail: {
    "title": "Reward Source Details",
    "rules": "Rules",
    "activityEarnings": "Active",
    "rechargeEarnings": "Recharge",
    "gameCommission": "Game",
    "incomeCommission": "Income",
    "totalEarnings": "Total",
    "yesterdayEarnings": "Yesterday",
    "todayEstimate": "Today",
    "todayActiveUsers": "Active Users",
    "currentRankReward": "Current Reward",
    "upgradeReward": "{count} more active to upgrade to {reward}",
    "maxRewardTier": "Max reward tier reached",
    "teamRevenue": "30-Day Team Revenue",
    "currentCommission": "Current Commission",
    "upgradeCommission": "Need {flow} revenue to reach {rate}",
    "maxCommissionTier": "Max commission tier reached",
    "invitedUsers": "Users Invited in 7 Days",
    "all": "All",
    "active": "Active",
    "inactive": "Inactive",
    "certified": "Verified",
    "agency": "Agency",
    "micTime": "Mic Time",
    "minutes": "min",
    "gameRevenue": "Game Revenue",
    "coins": "Coins",
    "loading": "Loading...",
    "noMore": "No More",
    "noData": "No Data",
    "total": "Total",
    "last7Days": "Last 7 Days",
    "yesterday": "Yesterday",
    "today": "Today",
    "level1Commission": "Level 1 Commission",
    "level2Commission": "Level 2 Commission",
    "totalIncome": "Total Income",
    "commissionRate": "Commission Rate",
    "upgradeGap": "{amount} to upgrade",
    "activeHelpUpdate": "Data updates in 10-15 mins",
    "activeHelpReward": "Rewards available at Home-Rewards at 10:00 next day",
    "rechargeHelpUpdate": "Data updates in 10-15 mins",
    "rechargeHelpReward": "Bonus credited immediately after recharge",
    "gameHelpUpdate": "Data updates in 10-15 mins",
    "gameHelpReward": "Rewards issued by system next day",
    "roomHelpUpdate": "Data updates in 10-15 mins",
    "roomHelpCommission": "Includes: your, Tier-1 and Tier-2 member commission",
    "roomHelpReward": "Rewards issued by system next day",
    "back": "Back",
    "viewHelp": "View help",
    "todayEstimateHelp": "Today's estimate help"
  },
};
